// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__8gw92","menuList":"Menu_menuList__kg4Tu","toolbar":"Menu_toolbar__XBG0C","icone":"Menu_icone__1PR+U"};